module.exports = __webpack_public_path__ + "media/images/home-subnav-background-c61e094f.png";